import script from "./FeedPreferences.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedPreferences.vue?vue&type=script&setup=true&lang=ts"

import "./FeedPreferences.vue?vue&type=style&index=0&id=53bd5809&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53bd5809"]])

export default __exports__